@file:OptIn(InternalResourceApi::class)

package org.maplibre.compose.generated

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/org.maplibre.compose.generated/"

@delegate:ResourceContentHash(-523_751_431)
internal val Res.drawable.add: DrawableResource by lazy {
      DrawableResource("drawable:add", setOf(
        ResourceItem(setOf(), "${MD}drawable/add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(350_920_419)
internal val Res.drawable.compass_needle: DrawableResource by lazy {
      DrawableResource("drawable:compass_needle", setOf(
        ResourceItem(setOf(), "${MD}drawable/compass_needle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(521_039_169)
internal val Res.drawable.info: DrawableResource by lazy {
      DrawableResource("drawable:info", setOf(
        ResourceItem(setOf(), "${MD}drawable/info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-314_306_518)
internal val Res.drawable.maplibre_logo: DrawableResource by lazy {
      DrawableResource("drawable:maplibre_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/maplibre_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_893_503_714)
internal val Res.drawable.remove: DrawableResource by lazy {
      DrawableResource("drawable:remove", setOf(
        ResourceItem(setOf(), "${MD}drawable/remove.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("add", Res.drawable.add)
  map.put("compass_needle", Res.drawable.compass_needle)
  map.put("info", Res.drawable.info)
  map.put("maplibre_logo", Res.drawable.maplibre_logo)
  map.put("remove", Res.drawable.remove)
}
